import { DocumentiService } from './../services/documenti.service';
import { AlertUtil } from './../utils/alert-util';
import { CommessaService } from './../services/commessa.service';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { ICommessa } from '../interfaces/ICommessa';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as Moment from 'moment'
import { IPagamento } from '../interfaces/IPagamento';
import { RequestBuilder } from '../classes/request-builder';
import { Loading } from '../utils/loading';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-payment-for-commessa-modal',
  templateUrl: './payment-for-commessa-modal.component.html',
  styleUrls: ['./payment-for-commessa-modal.component.css']
})
export class PaymentForCommessaModalComponent implements OnInit {

  listCommesse: ICommessa[]           //list of commesse
  it: any                             // Lingua del calendario
  newPaymentform: FormGroup
  commessaSelected: ICommessa = null  //commessa selected
  currentPayment: IPagamento          //payment for update
  isNewPayment: boolean               //determines whether modal was opend for new Payment

  uploadedFiles: any[] = [];          //for upload file
  nameAllegato: string = null                //name allegato

  constructor(private config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private commessaService: CommessaService,
    private alertUtil: AlertUtil,
    public ref: DynamicDialogRef,
    private documentiService: DocumentiService) {
    this.listCommesse = this.config.data.listCommesse
    this.currentPayment = this.config.data.payment

    this.isNewPayment = !this.currentPayment  //currentPayment undefined means this is a new Payment

    // set commessa select if Payment must be updated
    if (!this.isNewPayment) {
      this.commessaSelected = this.listCommesse[0]  //if update mode set commessaSelected as first element in the list (the only commessa in the list and disable select)
      this.nameAllegato = this.currentPayment.NomeAllegato
    }

    //build form group
    this.newPaymentform = this.formBuilder.group({
      'commessa': [{ value: !this.isNewPayment ? this.commessaSelected : '', disabled: !this.isNewPayment ? true : false }, Validators.required], // if update mode select commessaSelected
      'importo': [!this.isNewPayment ? this.currentPayment.Importo : '', Validators.required],
      'oggetto': [!this.isNewPayment ? this.currentPayment.Oggetto : '', Validators.required],
      'categoria_soa': [!this.isNewPayment ? this.currentPayment.Categoria_SOA : ''],
      'dataPagamento': [!this.isNewPayment ? this.formatDateForCalendar(this.currentPayment.Data_esecuzione) : '', Validators.required],
      'note': [!this.isNewPayment ? this.currentPayment.Note : '']
    })
  }

  ngOnInit() {
    this.setLanguageForCalendar()
  }

  // convenience getter for easy access to form fields
  get form() { return this.newPaymentform.controls }

  /**
  * language for calendar
  */
  setLanguageForCalendar() {
    /**
    * Lingua italiana nel calendario
    */
    this.it = {
      firstDayOfWeek: 1,
      dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
      today: 'Oggi',
      clear: 'Cancella'
    };
  }

  /**
   * drop down commesse event
   * @param commessa 
   */
  onCommessaSelected(event: any) {
    this.commessaSelected = event.value
  }


  onSubmit() {
    if (this.newPaymentform.valid) {
      //retrieve values from form
      let importo = this.newPaymentform.controls['importo'].value
      let oggetto = this.newPaymentform.controls['oggetto'].value
      let categoriaSOA = this.newPaymentform.controls['categoria_soa'].value
      let data = this.newPaymentform.controls['dataPagamento'].value
      let note = this.newPaymentform.controls['note'].value

      this.setObjCommessaNull();

      if(this.isNewPayment) {
        let pagamentoCommessa: IPagamento = {
          Importo: importo,
          Oggetto: oggetto,
          Categoria_SOA: categoriaSOA,
          Data_esecuzione: this.formatDateForSave(data),
          Note: note,
          Commessa: this.commessaSelected
        }
  
        this.callSavePagamento(pagamentoCommessa)
      }
      else {
        this.currentPayment.Importo = importo
        this.currentPayment.Oggetto = oggetto
        this.currentPayment.Categoria_SOA = categoriaSOA
        this.currentPayment.Data_esecuzione = this.formatDateForSave(data)
        this.currentPayment.Note = note

        this.callSavePagamento(this.currentPayment)
      }
    }
  }

  /**
   * format date from YYYY-MM-DDTHH:mm:ss to DD/MM/YYYY
   * @param dateValue item value
   */
  formatDateForSave(dateValue: Date): string {
    return Moment(dateValue).format("YYYY-MM-DDTHH:mm:ss")
  }

  /**
   * format date from YYYY-MM-DDTHH:mm:ss to DD/MM/YYYY
   * @param dateValue 
   */
  formatDateForCalendar(dateValue: string): Date {
    return new Date(dateValue)
  }

  /**
  * set null all object for commessa
  */
  private setObjCommessaNull() {
    this.commessaSelected.Cantieri = null;
    this.commessaSelected.Aggiudicatario = null;
    this.commessaSelected.Richieste = null;
    this.commessaSelected.Attivita = null;
  }

  /**
   * save SAL data
   */
  callSavePagamento(pagamentoCommessa: IPagamento) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(pagamentoCommessa, ["Commessa"])
    this.commessaService.savePagamentoforCommessa(reqBuilder).subscribe(response => {
      Loading.isLoading = false
      if (response.data) {
        if (this.uploadedFiles && this.uploadedFiles.length > 0) {
          let pagamentoSaved: IPagamento = response.data
          this.callSaveAllegato(pagamentoSaved)
        } else {
          this.pagamentoSaveSuccesMessage(response.data)
        }
      } else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      } else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * call service for save allegato
   */
  callSaveAllegato(pagamentoSaved: IPagamento) {
    Loading.isLoading = true
    this.commessaService.uploadAllegatoPagamento(this.uploadedFiles[0], this.uploadedFiles[0].name, pagamentoSaved.Id.toString()).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) { //return all allegatoObj
          this.pagamentoSaveSuccesMessage(pagamentoSaved);
        } else {
          this.alertUtil.showErrorAlert("LBL_ERROR_300")
        }
      })

  }

  /**
   * save success
   */
  pagamentoSaveSuccesMessage(paymentSaved: IPagamento) {
    this.alertUtil.showAlert("LBL_PAGAMENTO_SAVE_SUCCESS", null, null, null, () => {
      paymentSaved.NomeAllegato = this.nameAllegato
      this.ref.close(paymentSaved);
    });
  }

  /**
   * click button allega doc
   * @param event file
   * @param question question selected
   */
  uploadClick(event: any, upload: any) {
    this.uploadedFiles = []
    upload.clear()
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }
    this.nameAllegato = this.uploadedFiles[0].name
  }
}
